import { EnterPhoneNumberViewContainer as Component } from './EnterPhoneNumberViewContainer';
import { SourceProvider } from '../SourceProvider';
export var EnterPhoneNumberViewContainer = SourceProvider(Component);